import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Breadcrumb extends Component {
    render() {
        return (
            <section className="breadcrumb-area" style={{ backgroundImage: "url(" + (this.props.foto!=null?(this.props.foto):(process.env.PUBLIC_URL + "/assets/img/banner/09.jpg)")) }}>
                <div className="container">
                    <div className="breadcrumb-text">
                        <span></span>
                        <h2 className="page-title">{this.props.nome}</h2>
                        <ul className="breadcrumb-nav">
                            <li><Link to="/">Home</Link></li>
                            <li className="active">{this.props.nome}</li>
                        </ul>
                    </div>
                </div>
            </section>
        );
    }
}

export default Breadcrumb;